import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import { usePlatformsAwaitsContent } from '../../../../hooks/usePlatformsAwaitsContent';
import './Awaits.css';

const Awaits = () => {
  const { content, isLoading } = usePlatformsAwaitsContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, cta } = content;

  return (
    <section className="platforms-awaits">
      <div className="platforms-awaits__inner">
        <Reveal className="platforms-awaits__content">
          <h2 className="platforms-awaits__title">{title}</h2>
          {text ? <p className="platforms-awaits__text">{text}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="platforms-awaits__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </Reveal>
      </div>
    </section>
  );
};

export default Awaits;
